module.exports = {
	"slideIn": "_1mrQB-",
	"slideOut": "_1dGVhO",
	"slideUp": "_1-70mM",
	"slideDown": "wWsO1Z"
};